export function isMultiShare (alias) {
  if (alias) {
    return alias.toLowerCase().replace(/-|\s/g, '').startsWith('multishare')
  }
  return false
}

export function isSharedRoom (roomType) {
  return roomType.match(/Share$/)
}

export function revertMultiShareToQuadShare (roomType) {
  return isMultiShare(roomType) ? 'quadShare' : roomType
}

export function getBaseRoomType (room) {
  return isSharedRoom(room.roomType)
    ? revertMultiShareToQuadShare(room.roomType).replace('Share', '')
    : room.roomType
}
